import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    referrer: document.referrer,
    zoom: {
      min: 0.25,
      max: 1.5,
      step: 0.25,
      current: 1
    },
    dimensions: {
      width: undefined,
      height: undefined
    },
    videoData: null,
    loading: false,
    branding: null,
    errors: {
      params: false,
      request: false
    }
  },

  getters: {
    authenticated(state) {
      return (
        state.referrer.search(/(viewmedica|swarmwebhosting3|ondemand.aws-si-stage)\.com/) > -1 ||
        state.referrer.search(/localhost:3000\//) > -1 ||
        (state.branding.accountActive && state.branding.productActive)
      );
    },

    pages(state) {
      if (!state.videoData) return "";
      return Object.values(state.videoData.items[0].version.text).reduce(
        (acc, cur) => {
          return cur.b === 1 ? acc + 1 : acc;
        },
        1
      );
    },

    file(state) {
      return state.videoData
        ? state.videoData.items[0].file
        : state.route.params.file;
    },

    demo(state) {
      if (
        !state.branding.demo &&
        state.branding.productActive &&
        state.branding.accountActive
      ) {
        return false;
      }

      if (!state.branding.demo && state.branding.productExpiry) {
        return false;
      }

      return true;
    },

    development(state) {
      return state.route.params.file.search("V_") > -1
        ? "&development=true"
        : "";
    },

    copyright(state) {
      return state.videoData
        ? state.videoData.items[0].copyright
        : new Date().getFullYear();
    },

    disclaimer(state) {
      return state.videoData && state.videoData.items[0]
        ? state.videoData.items[0].brochureDisclaimer || ""
        : "";
    },

    pageTitle(state) {
      return state.videoData
        ? state.videoData.items[0].labels[state.route.params.language]
        : "";
    },

    pageStepData(state) {
      return p => {
        if (!state.videoData) return null;

        const previousPage = p - 1;
        const currentPage = p;
        let breaks = 0;

        return Object.values(state.videoData.items[0].version.text).filter(
          step => {
            const data = breaks >= previousPage && breaks < currentPage;
            breaks += step.b ? 1 : 0;
            return data;
          }
        );
      };
    },

    hasRequiredParams(state) {
      return (
        state.route.params.file &&
        state.route.params.client &&
        state.route.params.language
      );
    }
  },

  mutations: {
    FETCH_START(state) {
      state.errors.params = false;
      state.errors.request = false;
      state.loading = true;
    },

    FETCH_SUCCESS(state, payload) {
      state.videoData = payload;
      state.loading = false;
    },

    FETCH_ERROR(state) {
      state.loading = false;
      state.errors.request = true;
    },

    PARAMS_MISSING(state) {
      state.loading = false;
      state.errors.params = true;
    },

    BRANDING(state, payload) {
      state.branding = payload;
    },

    ZOOM_SET(state, payload) {
      state.zoom.current = payload;
    },

    PAGE_DIMENSIONS(state, { width, height }) {
      state.dimensions.width = width;
      state.dimensions.height = height;
    }
  },

  actions: {
    fetch({ state, commit, getters }) {
      return new Promise((resolve, reject) => {
        commit("FETCH_START");

        if (!getters.hasRequiredParams) {
          commit("PARAMS_MISSING");
          return reject(400);
        }

        const base = process.env.VUE_APP_VERSION_BASE_URL;
        axios
          .get(
            `${base}${state.route.params.client}/meta/${state.route.params.file}`,
            {
              headers: {
                "x-viewmedica-embedded-domain": process.env.VUE_APP_EMBEDDED_DOMAIN
              },
              params: { textLanguage: state.route.params.language }
            }
          )
          .then(response => {
            commit("FETCH_SUCCESS", response.data);
            resolve();
          })
          .catch(err => {
            commit("FETCH_ERROR", err);
            reject(500);
          });
      });
    },

    setScale({ state, commit }) {
      const maxW = window.innerWidth - 40;
      const pageW = 816;
      const pageH = 1056;

      let scale = maxW / pageW;

      if (scale > state.zoom.max) {
        scale = state.zoom.max;
      } else if (scale < state.zoom.min) {
        scale = state.zoom.min;
      }

      const actualW = pageW * scale;
      const actualH = pageH * scale;

      commit("ZOOM_SET", scale);
      commit("PAGE_DIMENSIONS", { width: actualW, height: actualH });
    }
  },

  modules: {}
});
